import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  ol {
    display: flex;
  }

  ol > li + li {
    margin-left: 1.5rem;
  }

  p {
    ${common.text};

    color: ${colors.pureWhite};
    font-family: 'Open Sans Regular', sans-serif;
    font-size: 1.2rem;
    margin-top: 2rem;
    text-transform: uppercase;
    text-decoration: none;
    border: none;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      margin-top: 3rem;
      width: 100%;
      padding: 0 2rem;

    }

    .container ol {
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }
  }
`
